<div class="top-row ps-3 navbar navbar-dark">
  <div class="container-fluid d-flex flex-column align-items-center py-3">
    <img src="assets/Logo.png" alt="Logo" class="logo-img mb-2" />
    <span class="navbar-brand">OFAC Maintenance</span>
  </div>
</div>

<div class="nav-scrollable">
  <nav class="flex-column">
    <div class="nav-item px-3">
      <a class="nav-link" routerLink="/flagged-contacts" routerLinkActive="active">
        <span class="bi bi-flag-fill" aria-hidden="true"></span> Flagged Contacts
      </a>
    </div>

    <div class="nav-item px-3">
      <a class="nav-link" routerLink="/exclusions" routerLinkActive="active">
        <span class="bi bi-x-circle-fill" aria-hidden="true"></span> Exclusions
      </a>
    </div>

    <div class="nav-item px-3">
      <a class="nav-link" routerLink="/audit-records" routerLinkActive="active">
        <span class="bi bi-file-earmark-text-fill" aria-hidden="true"></span> Audit Records
      </a>
    </div>
  </nav>
</div>

